<div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-div-container" style="position: relative;">

  <cp-twobarschart [params]="paramChart"></cp-twobarschart>

  <div *ngIf="plannedValue; else onlyAppropriate">
    <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-text-right">
      <p class="cp-font-bold cp-text-cost">{{ literalsCp?.strOrcado }}</p>
      <p class="cp-font-bold cp-text-cost">{{ inputItem.getFormattedNumber(plannedValue) }}</p>
    </div>
    <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 npl cp-text-left">
      <p class="cp-font-bold cp-text-appropriate">{{ literalsCp?.strApropriado }}</p>
      <p class="cp-font-bold cp-text-appropriate">{{ inputItem.getFormattedNumber(appropiateValue) }}</p>
    </div>
  </div>
  <ng-template #onlyAppropriate>
    <div style="text-align: center;">
      <p class="cp-font-bold cp-text-appropriate">{{ literalsCp?.strApropriado }}</p>
      <p class="cp-font-bold cp-text-appropriate">{{ inputItem.getFormattedNumber(appropiateValue) }}</p>
    </div>
  </ng-template>
  <po-loading-overlay [hidden]="isHideLoading" p-size="sm">
  </po-loading-overlay>
</div>